<app-side-menu>
  <div class="service-details-content">
    <div class="page-header">
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <button type="button" class="btn btn-outline-secondary me-3" (click)="goBack()">
            <i class="fas fa-arrow-left me-2"></i>
            Voltar
          </button>
          <div>
            <h1 class="page-title">
              <i class="fas fa-wrench me-3"></i>
              Detalhes do Serviço
            </h1>
          </div>
        </div>
      </div>
    </div>

  <!-- Loading -->
  <div *ngIf="loading" class="loading-container">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Carregando...</span>
    </div>
    <p>Carregando detalhes do serviço...</p>
  </div>

  <!-- Error -->
  <div *ngIf="error && !loading" class="alert alert-danger alert-dismissible fade show" role="alert">
    <i class="fas fa-exclamation-triangle"></i> {{ error }}
    <button type="button" class="close" (click)="error = null">
      <span>&times;</span>
    </button>
  </div>

  <!-- Detalhes -->
  <div *ngIf="service && !loading" class="details-container">
    <div class="row">
      <!-- Coluna Principal -->
      <div class="col-md-8">
        <!-- Card de Informações Básicas -->
        <div class="details-card">
          <div class="card-header">
            <div>
              <h3>{{ service.name }}</h3>
              <span class="service-code" *ngIf="service.code">{{ service.code }}</span>
            </div>
            <span class="badge" [ngClass]="{'badge-success': service.isActive, 'badge-secondary': !service.isActive}">
              {{ service.isActive ? 'Ativo' : 'Inativo' }}
            </span>
          </div>

          <div class="card-body">
            <div class="info-section">
              <h4><i class="fas fa-info-circle"></i> Informações Gerais</h4>
              
              <div class="info-row">
                <span class="info-label">Descrição:</span>
                <span class="info-value">{{ service.description || 'Sem descrição' }}</span>
              </div>

              <div class="info-row" *ngIf="service.category">
                <span class="info-label">Categoria:</span>
                <span class="info-value">
                  <span class="category-badge">{{ service.category }}</span>
                </span>
              </div>

              <div class="info-row" *ngIf="service.estimatedTimeMinutes">
                <span class="info-label">Tempo Estimado:</span>
                <span class="info-value">
                  <i class="fas fa-clock"></i> {{ formatTime(service.estimatedTimeMinutes) }}
                </span>
              </div>
            </div>

            <!-- Custos e Precificação -->
            <div class="info-section">
              <h4><i class="fas fa-dollar-sign"></i> Custos e Precificação</h4>

              <div class="pricing-grid">
                <div class="pricing-item">
                  <span class="pricing-label">Custo Base</span>
                  <span class="pricing-value">
                    {{ service.baseCost ? (service.baseCost | currency:'BRL':'symbol':'1.2-2') : '-' }}
                  </span>
                </div>

                <div class="pricing-item">
                  <span class="pricing-label">Custo Atual</span>
                  <span class="pricing-value">
                    {{ service.currentCost ? (service.currentCost | currency:'BRL':'symbol':'1.2-2') : '-' }}
                  </span>
                </div>

                <div class="pricing-item">
                  <span class="pricing-label">Margem de Lucro</span>
                  <span class="pricing-value">
                    {{ service.profitMarginPercentage ? service.profitMarginPercentage + '%' : '-' }}
                  </span>
                </div>

                <div class="pricing-item pricing-final">
                  <span class="pricing-label">Preço Final</span>
                  <span class="pricing-value final-price">
                    {{ calculateFinalPrice() | currency:'BRL':'symbol':'1.2-2' }}
                  </span>
                </div>
              </div>

              <!-- Cálculo Visual -->
              <div class="calculation-visual" *ngIf="service.currentCost && service.profitMarginPercentage">
                <div class="calculation-step">
                  <span>Custo Atual</span>
                  <span class="value">{{ service.currentCost | currency:'BRL':'symbol':'1.2-2' }}</span>
                </div>
                <div class="calculation-operator">+</div>
                <div class="calculation-step">
                  <span>Margem ({{ service.profitMarginPercentage }}%)</span>
                  <span class="value">
                    {{ (service.currentCost * service.profitMarginPercentage / 100) | currency:'BRL':'symbol':'1.2-2' }}
                  </span>
                </div>
                <div class="calculation-operator">=</div>
                <div class="calculation-step result">
                  <span>Preço Final</span>
                  <span class="value">{{ calculateFinalPrice() | currency:'BRL':'symbol':'1.2-2' }}</span>
                </div>
              </div>
            </div>

            <!-- Auditoria -->
            <div class="info-section">
              <h4><i class="fas fa-history"></i> Informações de Auditoria</h4>

              <div class="info-row">
                <span class="info-label">Criado em:</span>
                <span class="info-value">{{ service.createdAt | date:'dd/MM/yyyy HH:mm' }}</span>
              </div>

              <div class="info-row" *ngIf="service.createdBy">
                <span class="info-label">Criado por:</span>
                <span class="info-value">{{ service.createdBy }}</span>
              </div>

              <div class="info-row" *ngIf="service.updatedAt">
                <span class="info-label">Última atualização:</span>
                <span class="info-value">{{ service.updatedAt | date:'dd/MM/yyyy HH:mm' }}</span>
              </div>

              <div class="info-row" *ngIf="service.updatedBy">
                <span class="info-label">Atualizado por:</span>
                <span class="info-value">{{ service.updatedBy }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Coluna Lateral -->
      <div class="col-md-4">
        <!-- Card de Ações Rápidas -->
        <div class="quick-actions-card">
          <h4><i class="fas fa-bolt"></i> Ações Rápidas</h4>

          <button class="action-btn btn-block" (click)="editService()">
            <i class="fas fa-pen-to-square"></i>
            <div>
              <strong>Editar Serviço</strong>
              <small>Modificar informações do serviço</small>
            </div>
          </button>

          <button class="action-btn btn-block" (click)="toggleStatus()">
            <i class="fas" [ngClass]="service.isActive ? 'fa-toggle-off' : 'fa-toggle-on'"></i>
            <div>
              <strong>{{ service.isActive ? 'Desativar' : 'Ativar' }} Serviço</strong>
              <small>Alterar status de disponibilidade</small>
            </div>
          </button>

          <button class="action-btn btn-block btn-danger-outline" (click)="deleteService()">
            <i class="fas fa-trash-can"></i>
            <div>
              <strong>Excluir Serviço</strong>
              <small>Remover permanentemente</small>
            </div>
          </button>
        </div>

        <!-- Card de Estatísticas -->
        <div class="stats-card">
          <h4><i class="fas fa-chart-bar"></i> Estatísticas</h4>

          <div class="stat-item">
            <div class="stat-icon" [style.background]="service.isActive ? '#d4edda' : '#f8d7da'">
              <i class="fas fa-toggle-on" [style.color]="service.isActive ? '#28a745' : '#dc3545'"></i>
            </div>
            <div class="stat-info">
              <span class="stat-label">Status</span>
              <span class="stat-value">{{ service.isActive ? 'Ativo' : 'Inativo' }}</span>
            </div>
          </div>

          <div class="stat-item" *ngIf="service.category">
            <div class="stat-icon" style="background: #cfe2ff;">
              <i class="fas fa-tag" style="color: #0d6efd;"></i>
            </div>
            <div class="stat-info">
              <span class="stat-label">Categoria</span>
              <span class="stat-value">{{ service.category }}</span>
            </div>
          </div>

          <div class="stat-item" *ngIf="service.estimatedTimeMinutes">
            <div class="stat-icon" style="background: #fff3cd;">
              <i class="fas fa-clock" style="color: #ffc107;"></i>
            </div>
            <div class="stat-info">
              <span class="stat-label">Duração</span>
              <span class="stat-value">{{ formatTime(service.estimatedTimeMinutes) }}</span>
            </div>
          </div>

          <div class="stat-item">
            <div class="stat-icon" style="background: #d1e7dd;">
              <i class="fas fa-money-bill-wave" style="color: #198754;"></i>
            </div>
            <div class="stat-info">
              <span class="stat-label">Preço</span>
              <span class="stat-value">{{ calculateFinalPrice() | currency:'BRL':'symbol':'1.2-2' }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</app-side-menu>

